import { configureStore } from "@reduxjs/toolkit"
import { contactoSlice } from "features/Contactos/redux/slices/contactoSlice"
import { entidadBancariaSlice } from "features/Contactos/redux/slices/entidadBancariaSlice"
import { newDocumentoSettingsSlice } from "features/Crear/redux/slices/newDocumentoSettingsSlice"
import { newDocumentoSlice } from "features/Crear/redux/slices/newDocumentoSlice"
import { documentoSlice } from "features/Documentos/redux/documentosSlice"
import { articulosSlice } from "features/Inventario/redux/slices/articulosSlice"
import { catalogosSlice } from "features/Inventario/redux/slices/catalogosSlice"
import { categoriasSlice } from "features/Inventario/redux/slices/categoriasSlice"
import { aprobacionesSlice } from "features/User/redux/slices/approvalSlices"
import { empresaSlice } from "features/User/redux/slices/empresaSlice"
import { userSlice } from "features/User/redux/slices/userSlice"
import { validationsSlice } from "features/Validaciones/redux/slices/validationsSlice"
import { globalSlice } from "routes/globalSlice"

export const store = configureStore({
  reducer: {
    aprobaciones: aprobacionesSlice.reducer,
    articulos: articulosSlice.reducer,
    catalogos: catalogosSlice.reducer,
    categorias: categoriasSlice.reducer,
    contacto: contactoSlice.reducer,
    documentos: documentoSlice.reducer,
    empresa: empresaSlice.reducer,
    entidadBancaria: entidadBancariaSlice.reducer,
    global: globalSlice.reducer,
    newDocumento: newDocumentoSlice.reducer,
    newDocumentoSettings: newDocumentoSettingsSlice.reducer,
    user: userSlice.reducer,
    validations: validationsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  devTools: import.meta.env.NODE_ENV !== "production",
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store
